import CoreNavigationFooter from './CoreNavigationFooter';

export { type CoreNavigationFooterProps } from './CoreNavigationFooter';
export default CoreNavigationFooter;
